import { KeywordStatusTable } from "../components/KeywordStatusTable";
import { Notice } from "../components/Notice";
import { QueryErrorState, TabHeading, TabSkeleton } from "../components/tab-states";
import { useItemStatus } from "../data/queries";
import { ITEM_SCOPE_PARAM, useOpenMachineTab } from "../navigation";

/** What the machine has done to every keyword, in every market, right now. */
export function KeywordStatusTab() {
  const itemStatus = useItemStatus();
  const openTab = useOpenMachineTab();

  return (
    <div className="flex flex-col gap-4">
      <TabHeading
        title="Keyword Status"
        description="What the machine has done to every keyword, in every market, right now — and which of it is actually live on Amazon."
      />
      {itemStatus.isPending ? (
        <TabSkeleton />
      ) : itemStatus.isError ? (
        <QueryErrorState title="Keyword status unavailable" onRetry={() => itemStatus.refetch()} />
      ) : !itemStatus.data || itemStatus.data.length === 0 ? (
        <Notice title="No keyword status available">
          No keyword records were returned. Nothing is inferred and no mock data is shown.
        </Notice>
      ) : (
        // "View history" hands the item to the Change Log through the router.
        <KeywordStatusTable
          rows={itemStatus.data}
          onViewHistory={(itemKey) => openTab("change_log", { [ITEM_SCOPE_PARAM]: itemKey })}
        />
      )}
    </div>
  );
}
